import { render, staticRenderFns } from "./item-tag.vue?vue&type=template&id=3822c2e7&scoped=true&"
import script from "./item-tag.vue?vue&type=script&lang=js&"
export * from "./item-tag.vue?vue&type=script&lang=js&"
import style0 from "./item-tag.vue?vue&type=style&index=0&id=3822c2e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3822c2e7",
  null
  
)

export default component.exports